import React, { useEffect, useState } from 'react';
import { Button, Table, Input, Tooltip, Breadcrumb, Avatar, Switch } from 'antd';
import { toast } from 'react-toastify';
import { HomeOutlined } from '@ant-design/icons';
import { fetchClients, getAllClientEmail } from '../../../../services/users/usersApi';

const Clients = () => {
    const [clients, setClients] = useState([]);
    const [search, setSearch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage] = useState(10);
 
    const [client, setClient] = useState(null);
    const [loading, setLoading] = useState(true);

    const url_media = process.env.REACT_APP_URL_MEDIA;

    useEffect(() => {
        loadClients();
    }, [search, currentPage]);

    const loadClients = () => {
        fetchClients(search, perPage, currentPage)
            .then((response) => {
                setClients(response.data.users);
                setTotalRows(response.data.totalRows);
                setLoading(false);
            })
            .catch((error) => {
                toast.error('Error fetching clients.');
                setLoading(false);
            });
    };

    const handleEtatChange = (clientId, status) => {
        console.log(clientId, status);
    };

    const downloadExcel = () => {
        getAllClientEmail().then((response) => {
            
            const emailList = response.data.map(client => client.email).join('\n');
            const blob = new Blob([emailList], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', 'clients_emails.csv');
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });
    };

    const columns = [
        {
            title: 'Date',
            dataIndex: 'created_at',
            key: 'created_at',
            render: (created_at) => {
              if (!created_at) return '—';
              const date = new Date(created_at);
              const day = String(date.getDate()).padStart(2, '0');
              const month = String(date.getMonth() + 1).padStart(2, '0');
              const year = date.getFullYear();
              return `${day}-${month}-${year}`;
            },
          },
          
        {
            title: 'Username',
            dataIndex: 'username',
            key: 'username',
            render: (username, user) => (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    
                    <Avatar
                        src={user.photo_profil ? `${url_media}/${user.photo_profil}` : undefined}
                        style={{
                            background: user.photo_profil ? undefined : "var(--primary-color) !important",
                            color: 'white',
                        }}
                    >
                        <h5 style={{ marginTop: 1 }}>{user.photo_profil ? null : username.charAt(0).toUpperCase()}</h5>
                    </Avatar>
                    <span style={{ marginLeft: 8 }}>{username}</span>
                </div>
            ),
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
        },
        {
            title: 'whatssap',
            dataIndex: 'whatssap',
            key: 'whatssap',
        },
        {
            title: 'Code Postal',
            dataIndex: 'code_postal',
            key: 'code_postal',
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (status, client) => (
                <Switch
                    checked={status === "active"}
                    onChange={() => handleEtatChange(client.id, status)}
                />
            ),
        },
       
    ];

    return (
        <>
            <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h4 className='col-lg-10'>
                        <div className="mb-2">
                            <i className="bx bx-user me-2" />
                            <h3 style={{color:"var(--primary-color3) !important"}}>Clients</h3>
                        </div>
                        <Breadcrumb>
                            <Breadcrumb.Item>
                                <HomeOutlined />
                            </Breadcrumb.Item>
                            <Breadcrumb.Item style={{color:"var(--primary-color3) !important"}}>Clients</Breadcrumb.Item>
                        </Breadcrumb>
                    </h4>
                    <div className='col-lg-2 d-flex justify-content-end'>
                        <Button onClick={downloadExcel} type="primary" style={{minWidth:"100% !important"}}>Exporte emails</Button>
                    </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '10px 0' }}>
                    <Input
                        onChange={(e) => setSearch(e.target.value)}
                        placeholder="Rechercher"
                        value={search}
                        suffix={<i className="bi bi-search" />}
                        style={{ width: '200px' }}
                    />
                </div>
                <Table
                    dataSource={clients}
                    columns={columns}
                    pagination={{ current: currentPage, total: totalRows, pageSize: perPage, onChange: setCurrentPage }}
                    scroll={{ x: 1000 }}
                    loading={loading}
                />
            </div>
           
        </>
    );
};

export default Clients;
